import React from 'react';
import axios from 'axios';
import './AssetCard.css';

function AssetCard({ asset }) {
  if (!asset || !asset.id) {
    return null;
  }

  const handleDownload = async () => {
    if (!asset.id) return;
    
    try {
      const response = await axios.post(`/api/assets/${asset.id}/download`, {}, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', asset.originalName || 'download');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      alert('Failed to download file');
    }
  };

  const getFileIcon = (category) => {
    const icons = {
      vectors: '⚙',
      photos: '📷',
      psds: '📄',
      icons: '⭐',
      templates: '📋'
    };
    return icons[category] || '📁';
  };

  const getImageUrl = () => {
    if (asset?.filename) {
      return `/uploads/${asset.filename}`;
    }
    return null;
  };

  const isImage = asset?.filename && /\.(jpg|jpeg|png|gif|svg)$/i.test(asset.filename);

  return (
    <div className="asset-card">
      <div className="asset-preview">
        {isImage ? (
          <img src={getImageUrl()} alt={asset.title} className="asset-image" />
        ) : (
          <div className="asset-placeholder">
            <span className="asset-icon">{getFileIcon(asset.category)}</span>
          </div>
        )}
        <div className="asset-overlay">
          <button className="download-button" onClick={handleDownload}>
            Download
          </button>
        </div>
      </div>
      <div className="asset-info">
        <h3 className="asset-title">{asset?.title || 'Untitled'}</h3>
        {Array.isArray(asset?.tags) && asset.tags.length > 0 && (
          <div className="asset-tags">
            {asset.tags.slice(0, 3).map((tag, index) => (
              <span key={index} className="asset-tag">{tag}</span>
            ))}
          </div>
        )}
        <div className="asset-meta">
          <span className="asset-category">{asset?.category || '-'}</span>
          {asset?.downloadCount > 0 && (
            <span className="asset-downloads">{asset.downloadCount} downloads</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default AssetCard;
